import { css, cva } from "@stubhub/broadway-foundation/css";

export const nativeHeaderWrapper = cva({
  base: {
    touchAction: "none",
    position: "fixed",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBlock: "primitives.200",
    paddingInline: "primitives.400",
    width: "full",
    zIndex: "[3]",
    fontSize: "primitives.400",
    fontWeight: "bold",
    lineHeight: "primitives.500",
    transitionProperty: "[background-color, border-bottom]",
    transitionDuration: "change.quick",
    transitionTimingFunction: "change",
  },
  variants: {
    appearance: {
      transparent: {
        backgroundColor: "[transparent]", // No bg.transparent token exists
        color: "text.onDark",
      },
      opaque: {
        backgroundColor: "bg.surface",
        color: "text",
        borderBlockEndWidth: "thin",
        borderBlockEndStyle: "solid",
        borderBlockEndColor: "border",
      },
    },
  },
  defaultVariants: {
    appearance: "opaque",
  },
});

export const nativeBackButton = cva({
  base: {
    all: "unset",
    cursor: "pointer",
    touchAction: "none",
    marginInlineStart: "-primitives.50",
    height: "primitives.400",
    width: "primitives.400",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
    "& > svg": {
      transitionProperty: "[color]",
      transitionDuration: "change.quick",
    },
  },
  variants: {
    appearance: {
      opaque: { "& > svg": { color: "text" } },
      transparent: { "& > svg": { color: "text.onDark" } },
    },
  },
  defaultVariants: { appearance: "opaque" },
});

export const placeholderDiv = css({
  width: "primitives.800",
  height: "primitives.800",
});

export const sellTicketsLink = cva({
  base: {
    textAlign: "end",
    fontSize: "primitives.350",
    fontWeight: "regular",
    lineHeight: "primitives.500",
  },
  variants: {
    appearance: {
      opaque: { color: "text.link" },
      transparent: { color: "text.onDark" },
    },
  },
  defaultVariants: { appearance: "opaque" },
});
